import { get } from "../../utils/request";

export const getHeadersWoman = async () => {
  const res = await get("headers-woman");
  return res;
};

export const getHeadersMan = async () => {
  const res = await get("headers-man");
  return res;
};

export const getHeadersKids = async () => {
  const res = await get("headers-kids");
  return res;
};

export const getHeadersSports = async () => {
  const res = await get("headers-sports");
  return res;
};

export const getHeadersBrands = async () => {
  const res = await get("headers-brands");
  return res;
};

export const getHeadersTrend = async () => {
  const res = await get("headers-trending");
  return res;
};

export const getHeadersSales = async () => {
  const res = await get("headers-sales");
  return res;
};
